import logo from "./logo.svg";
import "./App.css";
import "./fonts/font.css";

import { BrowserRouter as Router, Routes, Link, Route } from "react-router-dom";

import Step1 from "./screens/Step1";
import { Step2 } from "./screens/Step2";
import { SignUpInterFace } from "./screens/SignUp/SignUpInterFace";
import { SignUpInfo } from "./screens/SignUp/SignUpInfo";
import { SignUpLoginInfo } from "./screens/SignUp/SignUpLoginInfo";
import SignUpTraining from "./screens/SignUp/SignUpTraining";
import SignUpProfile1 from "./screens/SignUp/SignUpProfile1";
import SignUpAthleteProfile from "./screens/SignUp/SignUpAthleteProfile";
import SignUpAthleteGoals from "./screens/SignUp/SignUpAthleteGoals";
import { UserHeader } from "./component/UserHeader";
import { Header } from "./component/Header";
import Layout from "./component/Layout";
import Dashboard from "./screens/Dashboard/Dashboard";
import { Split } from "./screens/Split/Split";
import SpeedStep1 from "./screens/Speed/SpeedStep1";
import SpeedStep2 from "./screens/Speed/SpeedStep2";
import SpeedStep from "./screens/Speed/SpeedStep";
import Strength from "./screens/Strength/Strength";
import ToolDetail from "./screens/Tools/ToolDetail";
import Tools from "./screens/Tools/Tools";
import TestStep2 from "./screens/LoadValocity/Test/TestStep2";
import TestResult from "./screens/LoadValocity/Test/TestResult";
import Train from "./screens/LoadValocity/Train/Train";
import TrainStep2 from "./screens/LoadValocity/Train/TrainStep2";
import TrainStep3 from "./screens/LoadValocity/Train/TrainStep3";
import Performance from "./screens/LoadValocity/Performance/Performance";
import RRTestStep1 from "./screens/RunRocket/Test/RRTestStep1";
import RRTestResult1 from "./screens/RunRocket/Test/RRTestResult1";
import RRTestResult2 from "./screens/RunRocket/Test/RRTestResult2";
import RRTrain from "./screens/RunRocket/Train/RRTrain";
import RRTrainStep2 from "./screens/RunRocket/Train/RRTrainStep2";
import RRTrainStep3 from "./screens/RunRocket/Train/RRTrainStep3";
import RRPerformance from "./screens/RunRocket/Perfomance/RRPerfomance";
import TestStep3 from "./screens/LoadValocity/Test/TestStep3";

function App() {
  return (
    <>
     
      <Router>
        <Routes>
          <Route path="/" element={ <Step1 />} />
          <Route path="/step2" element={ <Step2 />} />
          <Route path="/signupinterface" element={ <SignUpInterFace />} />
          <Route path="/signupinfo" element={ <SignUpInfo />} />
          <Route path="/signuplogininfo" element={ <SignUpLoginInfo />} />
          <Route path="/signuptraining" element={ <SignUpTraining />} />
          <Route path="/signupprofile1" element={ <SignUpProfile1 />} />
          <Route path="/signupathleteprofile" element={ <SignUpAthleteProfile />} />
          <Route path="/signupathletegolas" element={ <SignUpAthleteGoals/>} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/split" element={<Split />} />
          <Route path="/speedstep" element={<SpeedStep />} />
          <Route path="/strength" element={<Strength />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tooldetail" element={<ToolDetail />} />
          <Route path="/teststep2" element={<TestStep2 />} />
          <Route path="/teststep3" element={<TestStep3 />} />
          <Route path="/testresult" element={<TestResult />} />
          <Route path="/train" element={<Train />} />
          <Route path="/trainstep2" element={<TrainStep2 />} />
          <Route path="/trainstep3" element={<TrainStep3 />} />
          <Route path="/performance" element={<Performance  />} />
          <Route path="/rrteststep1" element={<RRTestStep1  />} />
          <Route path="/rrtestresult1" element={<RRTestResult1  />} />
          <Route path="/rrtestresult2" element={<RRTestResult2  />} />
          <Route path="/rrtrain" element={<RRTrain  />} />
          <Route path="/rrtrainstep2" element={<RRTrainStep2  />} />
          <Route path="/rrtrainstep3" element={<RRTrainStep3  />} />
          <Route path="/rrperfomance" element={<RRPerformance  />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
